import styled from "styled-components";

export default function Loader() {
  //{{ loading }: { loading: boolean }
  return (
    <LoaderStyle>
      <div></div>
    </LoaderStyle>
  );
}

const LoaderStyle = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff5d;
  backdrop-filter: blur(6px);
  z-index: 999999;

  div {
    aspect-ratio: 1;
    width: 100px;
    padding: 10px;
    box-sizing: border-box;
    display: grid;
    background: #ffffff5d;
    filter: blur(5px) contrast(10) hue-rotate(300deg);

    &:before,
    &:after {
      content: "";
      grid-area: 1/1;
      width: 40px;
      height: 40px;
      background: #ffff00;
      animation: l7 2s infinite;
    }
    &:after {
      animation-delay: -1s;
    }
    @keyframes l7 {
      0% {
        transform: translate(0, 0);
      }
      25% {
        transform: translate(100%, 0);
      }
      50% {
        transform: translate(100%, 100%);
      }
      75% {
        transform: translate(0, 100%);
      }
      100% {
        transform: translate(0, 0);
      }
    }
  }
`;
